import router from './router'
import * as fcmApi from './api.js'
import * as types from './store/mutation_types'
import store from './store'
var $script = require('scriptjs')

const env = process.env
const swUrl = `/public/service_worker.js`

const loadFirebase = () =>
	new Promise(function (rs, rj) {
		$script('https://www.gstatic.com/firebasejs/6.2.0/firebase-app.js', function () {
			$script('https://www.gstatic.com/firebasejs/6.2.0/firebase-messaging.js', function () {
				rs(firebase)
			})
		})
	})

export const init = async (accid, href) => {
	window.addEventListener('message', handleReceiveMessageFromWindowNotify)
	let firebase = await loadFirebase()
	//init firebase messaging
	if (!firebase.messaging.isSupported()) return

	firebase.initializeApp({
		projectId: env.VUE_APP_FIREBASE_PROJECT_ID,
		messagingSenderId: env.VUE_APP_FIREBASE_SENDER_ID,
	})

	const messaging = firebase.messaging()
	if (!messaging) return
	messaging.usePublicVapidKey(env.VUE_APP_FIREBASE_PUBLIC_VAPID_KEY)

	navigator.serviceWorker.addEventListener('message', event => {
		if (!event.data || !event.data.conversation_id) return
		router.push({
			name: 'convo',
			params: { convoId: event.data.conversation_id },
		})
	})

	let sw = await navigator.serviceWorker.register('service_worker.js', { scope: '/' })
	if (!sw) return

	messaging.useServiceWorker(sw)
	let controler = navigator.serviceWorker.controller
	controler &&
		controler.postMessage({
			account_id: accid,
			default_url: window.btoa(href),
		})

	var tk
	try {
		tk = await messaging.getToken()
	} catch (e) {
		return
	}

	if (!tk) return
	// already regitered, publish token
	store.commit(types.SET_FCM_TOKEN, tk)
	await fcmApi.updateFcmToken(store.state.userMask, tk)
}

async function handleReceiveMessageFromWindowNotify (event) {
	const data = event.data
	if (data.type !== 'SUBSCRIBED') return
	store.commit(types.SET_FCM_TOKEN, data.token)
	await fcmApi.updateFcmToken(store.state.userMask, data.token)
}
